import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import AdmissionHeader from './components/AdmissionHeader';
import AdmissionFooter from './components/AdmissionFooter';
import AiChatWidget from './components/AiChatWidget';
import Home from './pages/Home';
import Services from './pages/admission/Services';
import Countries from './pages/admission/Countries';
import Process from './pages/admission/Process';
import AdmissionContact from './pages/admission/AdmissionContact';

function App() {
  return (
    <BrowserRouter>
      <div className="ca-shell">
        <AdmissionHeader />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/countries" element={<Countries />} />
          <Route path="/process" element={<Process />} />
          <Route path="/contact" element={<AdmissionContact />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <AdmissionFooter />
        <AiChatWidget />
      </div>
    </BrowserRouter>
  );
}

export default App;
